import * as actionTypes from '../actionTypes';

export const helpersBlurAppend = () => {
    return {
        type: actionTypes.HELPERS_BLUR_APPEND
    };
};

export const helpersBlurRemove = () => {
    return {
        type: actionTypes.HELPERS_BLUR_REMOVE
    };
};


// WEBPACK FOOTER //
// ./src/_store/actions/helpers/blur.js